/**
 * Laatutili controller
 *
 * This class controls OPs laatutili calculator.
 */

 // Use jQuery as $ within this file scope.
const $ = jQuery;

import Dragdealer from './dragdealer';
import Common from './common';

/**
 * Class Laatutili
 */
export default class Laatutili {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Interest table.
        this.interestTable = [ 9, 5, 3.3, 2.5, 2.0, 1.7, 1.5, 1.4, 1.3, 1.2 ];

        this.updateTimer = null;

        this.manualInput = false;

        // Max loan amount
        this.maxAmount = 50000;

        // Max loan time.
        this.maxTime = 10;

        this.pageHasSlider = false;

    }

    /**
     * Cache dom elements for use in the class's methods.
     */
    cache() {

        // Amount.
        this.amount = $( '#amount' );

        // Payment.
        this.payment = $( '#payment' );

        // Create slider if amount and payment elements are on the page.
        if ( this.amount.length && this.payment.length ) {
            this.pageHasSlider = true;
            this.slider = new Dragdealer( 'slider_lainan_maara', { animationCallback: this.updateAmount.bind( this ), callback: this.updateAmount.bind( this ) });
        }

    }

    /**
     * All common events.
     */
    events() {
        const self = this;

        // Reflow slider.
        window.onresize( () => {
            this.slider.reflow();
        });

        // Call inputHandler function when amount input field is changed.
        this.amount.change( function( e ) {
            self.inputHandler( e );
        });

    }

    /**
     * Update loan amount.
     *
     * @param {*} x Slider x value.
     * @param {*} y Slider y value.
     */
    updateAmount( x, y ) {

        if ( ! this.manualInput ) {
            this.amount.val( 1000 + ( Math.round( ( ( this.maxAmount - 1000 ) / 500 ) * x ) * 500 ) ).trigger( 'change, input' );
            this.updateTotal();
        }

    }

    /**
     * Update total value.
     * Total value is payment amount per month.
     */
    updateTotal() {

        const loanAmount = parseInt( this.amount.val() );
        const loanTime = this.maxTime;
        const interest = this.interestTable[loanTime - 1];

        let newPayment = Math.round( loanAmount * ( interest / 100 ) );

        if ( newPayment < 50 ) {
            newPayment = 50;
        }

        this.payment.html( newPayment + ' \u20AC' );

    }

    /**
     * Handle input.
     *
     * @param {*} elem Current element.
     */
    inputHandler( elem ) {

        let input = elem.target;

        if ( this.updateTimer != null ) {
            clearTimeout( this.updateTimer );
            this.updateTimer = null;
        }

        this.manualInput = true;

            this.updateTimer = setTimeout( () => {
                let amount = parseInt( input.value );

                if ( isNaN( amount ) || amount < 1000 ) {
                    amount = 1000;
                } else if ( amount > this.maxAmount ) {
                    amount = this.maxAmount;
                }

                this.amount.val( amount );

                if ( this.pageHasSlider ) {
                    this.slider.setValue( ( amount - 1000 ) / ( this.maxAmount - 1000 ), 0, true );
                }

                this.updateTimer = null;

                setTimeout( () => {
                    this.manualInput = false;
                    this.updateTotal();
                }, 1000 );
            }, 500 );

    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();

        // Bind events only if page has slider.
        if ( this.pageHasSlider ) {
            this.events();
        }

    }

}
